__turbopack_context__.v({
  "colorButton": "pj6IVq_colorButton",
  "colorPicker": "pj6IVq_colorPicker",
  "disabled": "pj6IVq_disabled",
  "icon": "pj6IVq_icon",
});
